export const ReportComment = [
  "Harassment",
  "inappropriate Content",
  "Violation of Terms",
  "Threats",
  "Castfishing",
  "Unwanted Advances",
  "Unsolicited Explicit Content",
  "Privacy Concerns",
  "Scam or Spam",
  "Unwanted Advances"
];
